import api from "./api";

const clientService = {
    findClientByEmailOrDocument: (jwttoken, findUserBy, userKey) =>
        api.get(`/clients/find/findClientByEmailOrDocument?findUserBy=${findUserBy}&userKey=${userKey}`, { 
            headers: { 'Authorization': `Basic ${jwttoken}` } 
        }),
};

export default clientService;